import React, { Component } from 'react';
import InternalNavigation from '../InternalNavigation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectors, actions } from '../sagas/customers/show';
import { actions as refundActions } from '../sagas/refund';
import { selectors as accountSelectors } from '../sagas/account';
import { actions as accountActions } from '../sagas/account';
import { Row, Col } from 'react-bootstrap';
import MainDrawer from '../InternalNavigation/drawer';
import _ from 'lodash'
import '../stylesheets/App.css'
import '../stylesheets/showOrder.sass'
import { NavLink } from 'react-router-dom'

class Show extends Component {
  constructor(props) {
    super(props)
    this.state = {
      drawer: false
    };
    this.props.actions.accountActions.getAccountCompany()
    this.props.actions.showCustomerActions.getCustomer(this.props.match.params.customer_id)
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  tableLeft = (value) => {
    return(
      <div
        className={'table-left d-inline-block'}> {value} </div>
    )
  }

  render () {
    let customer_id = this.props.customer && this.props.customer.id
    let customer = this.props.customer && this.props.customer.attributes
    console.log(customer)
    return (
    <div>
      <MainDrawer
        position={'left'}
        openState={this.state.drawer}
        toggleDrawer={this.toggleDrawer}
        className='drawer'/>
      <InternalNavigation
        toggleDrawer={this.toggleDrawer}/>
        <div className={'show_order'}>
          <div>
            <div className='page-title'>
              { `${customer && customer.fullName}` }
            </div>
            <div style={{ borderRadius: 4, borderStyle: 'solid', borderWidth: 1, width: 630 }}>
              <table style={{ width: 630 }}>
                  { customer &&
                  <tbody>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Name') } </td>
                      <td className={'item'}> { customer.fullName } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Street Address') } </td>
                      <td className={'item'}> { customer.streetAddress } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Email') } </td>
                      <td className={'item'}> { customer.email } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Date of Birth') } </td>
                      <td className={'item'}> { customer.birthDate } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Phone') } </td>
                      <td className={'item'}> { customer.phoneNumber } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Drivers License Number') } </td>
                      <td className={'item'}> { customer.driverLicense } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Kegerator Customer?') } </td>
                      <td className={'item'}> { customer.kegerator ? 'True' : 'False' } </td>
                    </tr>
                </tbody>
                }
              </table>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20, marginBottom: 20 }}>
              <NavLink className={'new_customer_reservation_button'} to={`/new_reservation/${this.props.company_id}/customer/${customer_id}`}>
                Copy to New Reservation
              </NavLink>
            </div>
              { customer && customer.checkedOutScannables && customer.checkedOutScannables.map( product => {
                  return(
                      <div className='refund'>
                        <div className={'refund-row item product'}>
                          { product.type === 'HandTap'
                            ? <div className={'refund'}>
                                <div>
                                  Hand Tap
                                </div>
                                <button disabled = { !product.depositId } onClick={ () => this.props.actions.refundActions.refund(product.depositId) } className={ product.depositId ? 'button' : 'disabled-button' } type="submit">
                                  Refund Deposit
                                </button>
                              </div>
                            :
                            <div className={'refund'}>
                              <div>
                                {product.name}
                              </div>
                              <div>
                                {_.startCase(product.size)}
                              </div>
                              <div>
                                {product.price}
                              </div>
                              <button disabled = { !product.depositId } onClick={ () => this.props.actions.refundActions.refund(product.depositId) } className={ product.depositId ? 'button' : 'disabled-button' } type="submit">
                                Refund Deposit
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                  )
                })
              }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  customer: selectors.customer(store),
  company_id: accountSelectors.company_id(store)
})

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      showCustomerActions: bindActionCreators(actions, dispatch),
      refundActions: bindActionCreators(refundActions, dispatch),
      accountActions: bindActionCreators(accountActions, dispatch)
    }
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)((Show)));



// WEBPACK FOOTER //
// ./src/Customers/Show.jsx